import { logoutUser } from "./slices/userSlice"

export const performLogoutActions = (dispatch, isSelfLogout = false) => {
  dispatch(logoutUser({ isSelfLogout }))
}
